import { render } from "./CustomFilterItem.vue?vue&type=template&id=42615b72"
import script from "./CustomFilterItem.vue?vue&type=script&lang=js"
export * from "./CustomFilterItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__